<!--  -->
<template>
  <div>
    <div class="band_box">
      <div>
        <div class="serch_box search_box">
          <!-- <el-input v-model="obr.employee_no" placeholder="请输入自有员工编号" style="width:200px" />
          <el-input v-model="obr.name" placeholder="请输入员工姓名" style="width:200px;margin-left:10px" /> -->
          <el-input
            v-model="obr.corp_keywords"
            placeholder="企业id/企业名称"
            style="width:240px"
          />
          <el-input
            v-model="obr.keywords"
            clearable
            style="width:240px;"
            placeholder="自有员工编号/员工ID/员工姓名"
          />
          <el-button
            type="primary"
            class="search_icon"
            icon="el-icon-search"
            @click="secahclkick"
          />
        </div>
        <div class="choses_box">
          <div
            class="select_box"
            :class="[fullName?'choose_blockr':'']"
            @click="whole"
          />
          <div
            v-if="fullName"
            @click="whole"
          >
            取消全选
          </div>
          <div
            v-else
            @click="whole"
          >
            全选
          </div>
        </div>
        <div class="choose_allblock">
          <div
            v-for="item,index in arr"
            :key="index"
            :class="[item.tips?'have ':'']"
            class="choose_block"
          >
            <!-- {{ item.canChecked }} -->
            <div
              v-if="item.can_checked === 9"
              class="select_boxone"
            />
            <div
              v-else
              class="select_box"
              :class="[item.tips?'choose_blockr':'']"
              @click="itenclick(item,index)"
            />
            <span>{{ item.name }}({{ item.corp_name }})</span>
          </div>
        </div>

      </div>
      <div class="rigboxr">
        <div class="choiceofficialaccount">选中的员工
          <el-button
            type="primary"
            @click="number_import = true"
          >快捷导入</el-button>
          <el-button
            style="margin-bottom: 20px"
            @click="clearEmployee"
          >全部清空</el-button>
        </div>
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.employee_no,index)"
        >
          {{ itemr.name }}({{ itemr.corp_name }})
        </el-tag>
      </div>
    </div>
    <pagination-right
      style="padding:0;margin-top:20px"
      :total="total"
      :current-page="obr.page"
      :page-size="30"
      :page-sizes="[10,20,30]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div class="que_box">
      <el-button
        type="primary"
        @click="quebtn"
      >确定</el-button>
    </div>
    <el-dialog
      title="员工编号导入"
      :visible.sync="number_import"
      :append-to-body="true"
      width="600px"
      @close="gunwebi"
    >
      <el-input
        v-model="employee_nos"
        type="textarea"
        :rows="3"
        placeholder="请输入员工编号，输入多个请用英文逗号隔开"
        @blur="emblur"
      />
      <div style="margin: 20px 0;" />
      <el-input
        v-model="names"
        type="textarea"
        :rows="3"
        placeholder="请输入员工名称，输入多个请用英文逗号隔开"
        @blur="namesblur"
      />
      <div style="margin: 20px 0;" />
      <div style="display: flex;justify-content: space-between;align-items: center">
        <div style="width: 45px">
          企业名称:
        </div>
        <el-input
          v-model="corp_names"
          type="textarea"
          :rows="2"
          placeholder="请输入企业名称，输入多个请用英文逗号隔开(如不输入,则会导入所有企业下包含当前员工编号和员工名称的员工)"
          @blur="cnsblur"
        />
      </div>
      <div style="margin: 20px 0;" />
      <el-checkbox
        v-if="corp_allids.length!=0"
        v-model="checkAll"
        :indeterminate="isIndeterminate"
        @change="handleCheckAllChange"
      >全选</el-checkbox>
      <div style="margin: 15px 0;" />
      <el-checkbox-group
        v-model="corp_idsow"
        @change="handleCheckedCitiesChange"
      >
        <el-checkbox-button
          v-for="city in corp_allids"
          :key="city.corp_id"
          :label="city.corp_id"
        >{{ city.corp_name }}</el-checkbox-button>
      </el-checkbox-group>
      <div style="margin: 15px 0;" />
      <div style="margin: 15px 0;" />
      <el-button
        type="primary"
        @click="getEmployees()"
      >提交</el-button>
      <el-button
        type="info"
        @click="gunwebi"
      >取消</el-button>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import { getEmployees, spCorpcorpUsersList } from '@/api/officialaccount.js'
export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      arr: [],
      arrs: [],
      arrsw: [],

      obr: {
        employee_no: null,
        name: null,
        sp_strategy_no: null,
        page: 1,
        pageSize: 30,
        corp_id: null,
        keywords: null,
        corp_keywords: null
      },
      total: null,
      sp_strategy_no: null,
      number_import: false,
      employee_nos: [],
      names: [],
      corp_names: [],
      isIndeterminate: true,
      corp_allids: [],
      checkAll: false,
      corp_idsow: []
    }
  },
  computed: {
    fullName: function() {
      return this.arr
        .filter(num => {
          return num.can_checked !== 9
        })
        .every(function(item) {
          return item.tips === true
        })
    }
  },
  created() {},
  mounted() {},
  methods: {
    secahclkick() {
      this.obr.page = 1
      this.list()
    },

    // 点击确定
    async quebtn() {
      console.log('arrs', this.arrs)
      this.arrsw = []
      this.arrsw = this.arrs.map(item => {
        // item是数组中的每一个值
        return item.employee_no
      })
      if (this.arrs.length === 0) {
        this.$message.error('请选择要绑定的员工')
        return
      }
      this.$emit('bandarr', this.arrs)
      console.log('this.arrs', this.arrs)
    },

    itenclick(item, index) {
      item.tips = !item.tips
      if (!item.corp_id) {
        console.log(item, '123123123213')
      }
      if (item.tips) {
        this.arrs.push({ employee_no: item.employee_no, name: item.name, corp_id: item.corp_id, corp_name: item.corp_name, user_id: item.user_id })
      } else {
        const index = this.arrs.findIndex(items => {
          return items.employee_no === item.employee_no
        })
        this.arrs.splice(index, 1)
      }
    },
    whole() {
      if (this.fullName === true) {
        // if (this.arrs.length === this.arr.length) {
        console.log('666')
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = false
            const index = this.arrs.findIndex(items => {
              return items.employee_no === item.employee_no
            })
            this.arrs.splice(index, 1)
          }
        })
      } else {
        console.log('777')
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = true
            this.arrs.map(re => re.employee_no).includes(item.employee_no) || this.arrs.push({ employee_no: item.employee_no, name: item.name, corp_id: item.corp_id, user_id: item.user_id })
          }
        })
        // this.arr.forEach((item) => {
        //   this.arrs.includes(item.id) || this.arr.push(item.id)
        // })
      }
    },
    rightclick(employee_no, index) {
      console.log(employee_no, index)
      this.arrs.splice(index, 1)
      this.arr.findIndex(items => {
        if (items.employee_no === employee_no) {
          items.tips = false
        }
      })
    },
    sendr(id, arr) {
      // this.obr.sp_strategy_no = id
      // this.sp_strategy_no = id
      this.obr.corp_id = id
      console.log('arr111', arr)
      // eslint-disable-next-line eqeqeq
      if (arr != undefined) {
        this.arrs = arr
      }

      this.list()
    },
    async list() {
      const data = await spCorpcorpUsersList(this.obr)
      this.total = data.data.total
      data.data.list.forEach(item => {
        item.tips = false
        item.can_checked = 1
      })
      this.arr = data.data.list
      this.arr.forEach(item => {
        // console.log('item', item)
        this.arrs.forEach(items => {
          if (items.employee_no === item.employee_no) {
            console.log('items', item)
            item.tips = true
          }
        })
      })
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      console.log('111')
      this.obr.pageSize = e
      this.obr.page = 1
      this.list()
    },
    fetchCurrentPage(e) {
      this.obr.page = e
      this.list()
    },
    set(id) {
      this.arrs.forEach(item => {
        if (item.employee_no === id) {
          item.tips = false
        }
      })
    },
    clearEmployee() {
      this.arrs = []
      this.arr.forEach(item => {
        item.tips = false
      })
    },
    async getEmployees() {
      if (this.confirm === 1 && this.corp_idsow.length === 0) {
        this.$message({
          message: '请选择要选中的人员的企业',
          type: 'error'
        })
        return
      }
      const data = await getEmployees({
        names: this.names,
        employee_nos: this.employee_nos,
        corp_names: this.corp_names,
        confirm: this.confirm,
        corp_ids: this.corp_idsow
      })
      if (data.code === 201) {
        console.log('201', data.data.corp)
        this.$message({
          message: '您导入的员工存在多企业，请选择后再次点击提交',
          type: 'error'
        })
        this.confirm = 1
        if (data.data.corp.length !== 0) {
          this.corp_allids = []
          this.corp_allids = data.data.corp
          this.corp_idsow = []
          this.corp_idsow = this.corp_allids.map(item => {
            return item.corp_id
          })
          this.isIndeterminate = false
          this.checkAll = true
        }
      } else {
        if (this.arrs.length === 0) {
          this.arrs = data.data.employee
          this.arr.forEach(item => {
            if (data.data.employee != null) {
              const match = data.data.employee.find(d => d.employee_no === item.employee_no)
              if (match) {
                item.tips = true
              }
            }
          })
        } else {
          this.arr.forEach(item => {
            if (data.data.employee != null) {
              const match = data.data.employee.find(d => d.employee_no === item.employee_no)
              if (match) {
                item.tips = true
              }
            }
          })

          if (data.data.employee != null) {
            data.data.employee.forEach(item => {
              const match = this.arrs.find(d => d.employee_no === item.employee_no)
              if (match) {
                console.log('11')
              } else {
                console.log('push')
                this.arrs.push(item)
              }
            })
          }
        }
        console.log('this.arrs', this.arrs)
        // this.arrs = data.data
        this.$message({
          message: '导入成功',
          type: 'success'
        })
        this.number_import = false
        this.employee_nos = ''
        this.corp_names = []
        this.names = ''
      }
    },
    gunwebi() {
      this.number_import = false
      this.confirm = 0
      this.corp_allids = []
      this.corp_idsow = []
      this.isIndeterminate = false
      this.checkAll = false
    },
    emblur() {
      this.employee_nos = this.employee_nos.replace(/\n/g, ',').replace(/\s+/g, '').replace(/[，]/g, ',')
      console.log('val', this.employee_nos)
    },
    namesblur() {
      this.names = this.names.replace(/\n/g, ',').replace(/\s+/g, '').replace(/[，]/g, ',')
      console.log('val', this.names)
    },
    cnsblur() {
      const corpName = this.corp_names.replace(/\n/g, ',').replace(/\s+/g, '').replace(/[，]/g, ',')
      this.corp_names = corpName ? corpName.split(',') : []
    },
    handleCheckedCitiesChange(value) {
      console.log('value', value, this.corp_idsow.length)
      const checkedCount = value.length
      this.checkAll = checkedCount === this.corp_allids.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.corp_allids.length
    },
    handleCheckAllChange(val) {
      console.log(val)
      if (val === true) {
        console.log('true')
        this.corp_idsow = []
        this.corp_idsow = this.corp_allids.map(item => {
          return item.corp_id
        })
      } else {
        this.corp_idsow = []
        console.log('false')
      }
      this.isIndeterminate = false
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox {
  padding: 30px;
}
.que_box {
  margin-top: 20px;
}
.have {
  color: #409eff;
}
.serch_box {
  display: flex;
  margin-bottom: 10px;
}
.search_icon {
  margin-left: 10px;
}
.band_box {
  display: flex;
}
.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.select_boxone {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
.choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
.choose_blockr {
  background: #409eff;
}
.rigboxr {
  margin-left: 75px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}
:-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.choiceofficialaccount {
  margin-bottom: 10px;
}
.select_spacing {
  margin-bottom: 5px;
}
.choose_allblock {
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
@media (max-width: 768px){
  .band_box{
    flex-direction: column;
  }
  .rigboxr{
    margin-left:0;
    padding-top:4vw;
    padding-left:0px;
    border:none;
    border-top:1px solid #ccc;
  }
}
</style>
